import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { ParamValueModel } from '../../../../../models/ParamValueModel';
import { User } from '../../../../../models/User';

declare var jQuery;

@Component({
    selector: 'domain-brand-safety-risk',
    templateUrl: './brand-safety-risk.html'
})

export class DomainBrandSafetyRisk implements OnInit {
    @Input() domain;
    @Input() region;
    @Input() device;
    @Input() data;
    @Input() month;
    @Input() os;
    @Output() anchorClick = new EventEmitter<string>();
    @Output() toAppDiscovery: EventEmitter<ParamValueModel> = new EventEmitter<ParamValueModel>();

    tooltipTemplate = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';
    isPopup: boolean;
    isDomainSearchEnabled: boolean;

    get isFreemium (): boolean {
      return this._user.isFreemium();
    }

    constructor(private _router: Router, private _user: User,
                private _activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        setTimeout(fn => {
            jQuery('[enTooltip]').tooltip({animation: false});
        }, 100);
        this.isDomainSearchEnabled = this._user.domainSearchEnabled();
    }

    goToSection(anchor:string) {
        this.anchorClick.emit(anchor);
    }

    getSellerParam(trustedSellerName: string) {
        return encodeURIComponent('trustedSellerName=' + trustedSellerName);
    }

    goToAppDiscovery(param: string, paramValue: string) {
        this.toAppDiscovery.emit({param: param, paramValue: paramValue});
    }

    getRating(paramValue: string) {
        if (paramValue === 'low') { paramValue = 'L'; }
        if (paramValue === 'medium') { paramValue = 'M'; }
        if (paramValue === 'high') { paramValue = 'H'; }
        return paramValue;
    }
}
